export const PROFILE_STUDENT_RESUME_UPLOAD_REQUEST = 'profile/student-resume-upload-request'
export const PROFILE_STUDENT_RESUME_UPLOAD_SUCCESS = 'profile/student-resume-upload-success'
export const PROFILE_STUDENT_RESUME_UPLOAD_FAILED = 'profile/student-resume-upload-failed'
